import { Autocomplete, TextField, Stack, useTheme } from "@mui/material";
import { useGridApiContext } from "@mui/x-data-grid";

export default function EditCellAutoComplete({
  id,
  field,
  value,
  lista,
  disabled = false,
  pre = true,
  setIsEdit = () => {},
  selected,
}) {
  const apiRef = useGridApiContext();
  const theme = useTheme();
  const options = lista.map((option) => option[field]);

  const onChange = (event, newInputValue) => {
    setIsEdit((data) => (data.includes(id) ? data : [...data, id]));
    apiRef.current.setEditCellValue({
      id,
      field,
      value: newInputValue || null,
      debounceMs: 1,
    });
  };
  const onClose = (event, newInputValue) => {
    apiRef.current.stopCellEditMode({ id, field });
  };

  return (
    <Autocomplete
      value={value}
      freeSolo
      onChange={onChange}
      onInputChange={onChange}
      blurOnSelect={pre}
      openOnFocus={pre}
      autoSelect
      onClose={onClose}
      disabled={disabled}
      sx={{
        border: selected ? "1px solid" + theme.palette.primary.main : null,
        p: "0px 10px",
        width: "100%",
        fontSize: 13,
        height: "100%",
      }}
      options={options}
      //getOptionLabel={(option) => option.toUpperCase() || ""}
      InputProps={{
        disableUnderline: true,
      }}
      renderInput={(params) => (
        <TextField
          autoFocus
          //onChange={onChangeTextField}
          autoComplete="off"
          key={"text" + field + id}
          {...params}
          variant="standard"
          slotProps={{
            input: {
              ...params.InputProps,
              disableUnderline: true,
              style: { fontSize: "13px", padding: "3px 0px" },
            },
          }}
        />
      )}
    />
  );
}
